import styled from 'styled-components';
import { baseStyles, baseProps } from './base.style';
import { containerStyles, containerProps } from './container.style';
import { breakpointStyles, border, getPropTypes } from './utils';

export const RowChild = styled.div<StyleProps>`
  ${baseStyles}
  ${containerStyles}
  ${breakpointStyles(baseStyles)}
  ${breakpointStyles(containerStyles)}
  ${breakpointStyles(border)}
`;

export const listProps = {
  ...baseProps,
  ...containerProps,
};

RowChild.propTypes = getPropTypes(listProps);

RowChild.defaultProps = {
  alignItems: 'center',
  flex: true,
  justifyContent: 'space-between',
  padding: {
    bottom: '24px',
    top: '24px',
  },
  width: '100%',
};
